import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between section-container background-gray" }
const _hoisted_2 = { class: "page-title q-py-lg" }
const _hoisted_3 = { class: "section-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "CPA", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "RevShare", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = ["alt", "src"]
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { class: "row justify-between items-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "row justify-start items-center"
}
const _hoisted_15 = {
  class: "col-12 q-py-lg q-px-md table-mobile-even-bg",
  style: {"border-top":"1px solid var(--border-color)","background":"#FBFBFB"}
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-12 flex items-center q-mb-md" }
const _hoisted_18 = { class: "additional-text q-mr-sm" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12 q-mb-sm" }
const _hoisted_22 = { class: "additional-text text-weight-bold" }
const _hoisted_23 = { class: "col-6 q-mb-md" }
const _hoisted_24 = { class: "additional-text" }
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = { class: "additional-text" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-12 q-mb-sm" }
const _hoisted_30 = { class: "additional-text text-weight-bold" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "additional-text" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-12 q-mb-sm" }
const _hoisted_36 = { class: "additional-text text-weight-bold" }
const _hoisted_37 = { class: "col-6 q-mb-md" }
const _hoisted_38 = { class: "additional-text" }
const _hoisted_39 = { class: "col-6" }
const _hoisted_40 = { class: "additional-text" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-12 q-mb-sm" }
const _hoisted_44 = { class: "additional-text text-weight-bold" }
const _hoisted_45 = { class: "col-6 q-mb-md" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text" }, "Host/Reg", -1)
const _hoisted_47 = { class: "col-6" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text" }, "Host/Dep", -1)
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text" }, "Reg/Dep", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_52 = { class: "row" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 q-mb-sm" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "additional-text text-weight-bold" }, "CPA")
], -1)
const _hoisted_54 = { class: "col-6 q-mb-md" }
const _hoisted_55 = { class: "additional-text" }
const _hoisted_56 = { class: "col-6" }
const _hoisted_57 = { class: "additional-text" }
const _hoisted_58 = { class: "col-12" }
const _hoisted_59 = { class: "additional-text" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_61 = { class: "row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 q-mb-sm" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "additional-text text-weight-bold" }, "RevShare")
], -1)
const _hoisted_63 = { class: "col-12" }
const _hoisted_64 = { class: "additional-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_ExpandableFilters = _resolveComponent("ExpandableFilters")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('statistics')), 1),
        _createVNode(_component_q_btn, {
          "no-caps": "",
          "icon-right": _ctx.heroOutline24ArrowDownTray,
          class: "q-btn__main-size text-weight-bold",
          label: "Export",
          color: "primary",
          outline: "",
          onClick: _ctx.onExport
        }, null, 8, ["icon-right", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ExpandableFilters, {
          onReset: _ctx.resetFilters,
          onChange: _ctx.onChangeFilters,
          onChangeAll: _ctx.changeAll,
          onExport: _ctx.onExport,
          "current-filters": _ctx.filters
        }, null, 8, ["onReset", "onChange", "onChangeAll", "onExport", "current-filters"])
      ]),
      _createVNode(_component_q_table, {
        rows: _ctx.rows,
        columns: _ctx.columns,
        "row-key": "id",
        "column-sort-order": "da",
        separator: "cell",
        class: "multirow-table",
        pagination: _ctx.pagination,
        "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagination) = $event)),
        loading: _ctx.loading,
        onRequest: _ctx.onRequest,
        "binary-state-sort": "",
        flat: "",
        "hide-pagination": "",
        "rows-per-page-label": _ctx.$t('rows_per_page')
      }, _createSlots({
        header: _withCtx((props) => [
          _createVNode(_component_q_tr, { class: "text-left" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_th, {
                key: "groupByField",
                props: props,
                rowspan: "2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.getGroupedField('name')), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, { colspan: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('traffic')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_th, { colspan: "1" }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('regs')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_th, { colspan: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('first_dep')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_th, { colspan: "3" }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('rates')) + ", %", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_th, { colspan: "3" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_q_th, { colspan: "1" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_q_tr, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_th, {
                key: "clicks",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('clicks')), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "uniqueClicks",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('uniqs')), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "registrationCount",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('count')), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "firstDepositCount",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('count')), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "firstDepositSum",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('sum')) + ", $", 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "crReg",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Host/Reg")
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "crFtd",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Host/Dep")
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "crFtdReg",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Reg/Dep")
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "approvedSum",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('approved')), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "holdSum",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('hold')), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "rejectedSum",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('rejects')), 1)
                ]),
                _: 2
              }, 1032, ["props"]),
              _createVNode(_component_q_th, {
                key: "revShareRevenueSum",
                props: props
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('income')), 1)
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 2
          }, 1024)
        ]),
        "body-cell-groupByField": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              (_ctx.filters.groupBy === 'offerId')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.offers[props.row.offerId]), 1))
                : (_ctx.filters.groupBy === 'campaignId')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.campaigns[props.row.campaignId]), 1))
                  : (_ctx.filters.groupBy === 'landingId')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.landings[props.row.landingId]), 1))
                    : (_ctx.filters.groupBy === 'geoId')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                          _createElementVNode("img", {
                            style: {"user-select":"none","display":"initial"},
                            class: "q-mr-xs",
                            height: "10",
                            width: "15",
                            alt: _ctx.geos[props.row.geoId],
                            src: 
                `http://purecatamphetamine.github.io/country-flag-icons/3x2/${
                  _ctx.geos[props.row.geoId]
                }.svg`
              
                          }, null, 8, _hoisted_10),
                          _createTextVNode(" " + _toDisplayString(_ctx.geos[props.row.geoId] || '??') + " ", 1),
                          _createVNode(_component_q_tooltip, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.geosNames[props.row.geoId] || 'Неизвестно'), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.getGroupedField('field', props.row)), 1))
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        "body-cell-registrationCount": _withCtx((props) => [
          _createVNode(_component_q_td, {
            props: props,
            onClick: _withModifiers(($event: any) => (
            _ctx.detailConversions({
              [_ctx.filters.groupBy]: props.row[_ctx.filters.groupBy],
              eventType: _ctx.eventTypes.Registration,
            })
          ), ["stop"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "",
                class: "link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.row.registrationCount || 0), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["props", "onClick"])
        ]),
        "body-cell-firstDepositCount": _withCtx((props) => [
          _createVNode(_component_q_td, {
            props: props,
            onClick: _withModifiers(($event: any) => (
            _ctx.detailConversions({
              [_ctx.filters.groupBy]: props.row[_ctx.filters.groupBy],
              rewardTypes: [
                _ctx.rewardType.FTD,
                _ctx.rewardType.CPA,
                _ctx.rewardType.BL,
                _ctx.rewardType.RevShare,
              ],
              eventType: _ctx.eventTypes.FirstDeposit,
            })
          ), ["stop"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "",
                class: "link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.row.firstDepositCount || 0), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["props", "onClick"])
        ]),
        _: 2
      }, [
        (_ctx.rows?.length)
          ? {
              name: "bottom-row",
              fn: _withCtx(() => [
                _createVNode(_component_q_tr, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_td, {
                      class: "",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('total')) + ":", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.total('clicks', 'sum')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.total('uniqueClicks', 'sum')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      props: _ctx.props,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
              _ctx.detailConversions({
                eventType: _ctx.eventTypes.Registration,
              })
            ), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: "",
                          class: "link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.total('registrationCount', 'sum')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["props"]),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      props: _ctx.props,
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
              _ctx.detailConversions({
                rewardTypes: [
                  _ctx.rewardType.FTD,
                  _ctx.rewardType.CPA,
                  _ctx.rewardType.BL,
                  _ctx.rewardType.RevShare,
                ],
                eventType: _ctx.eventTypes.FirstDeposit,
              })
            ), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: "",
                          class: "link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.total('firstDepositCount', 'sum')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["props"]),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.total('firstDepositSum', 'sum')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.totalCrReg), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.totalCrFtd), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.totalCrFtdReg), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.total('approvedSum', 'sum')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.total('holdSum', 'sum')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.total('rejectedSum', 'sum')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_td, {
                      class: "text-right",
                      colspan: "1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.total('revShareRevenueSum', 'sum')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_td, {
                  class: "q-mt-md",
                  colspan: "100%"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        (_ctx.pagesNumber === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                          : _createCommentVNode("", true),
                        (_ctx.pagesNumber !== 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_q_pagination, {
                                modelValue: _ctx.paginationPage,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paginationPage) = $event)),
                                color: "grey-10",
                                "text-color": "white",
                                "max-pages": "3",
                                max: _ctx.pagesNumber,
                                "direction-links": ""
                              }, null, 8, ["modelValue", "max"]),
                              _createVNode(_component_q_btn, {
                                onClick: _ctx.selectAllPagination,
                                label: "All",
                                color: "grey-10",
                                "text-color": "white",
                                "no-caps": "",
                                flat: ""
                              }, null, 8, ["onClick"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, _toDisplayString(`${_ctx.dashboardTotal.offersCount} ${_ctx.$t('offers_count')}`), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              key: "0"
            }
          : undefined,
        (_ctx.$q.screen.width <= 1199)
          ? {
              name: "item",
              fn: _withCtx((props) => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('date')), 1),
                      _createTextVNode(" " + _toDisplayString(props.row.groupByField), 1)
                    ])
                  ]),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('traffic')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('clicks')), 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.clicks), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('uniqs')), 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.uniqueClicks), 1)
                    ])
                  ]),
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('regs')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('count')), 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.registrationCount), 1)
                    ])
                  ]),
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('first_dep')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('count')), 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.firstDepositCount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('sum')) + ", $", 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.firstDepositSum), 1)
                    ])
                  ]),
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('rates')) + ", %", 1)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("div", null, _toDisplayString(props.row.crUniqueReg), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", null, _toDisplayString(props.row.cr), 1)
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("div", null, _toDisplayString(props.row.crFtdReg), 1)
                    ])
                  ]),
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('approved')), 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.approvedSum), 1)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('hold')) + ", $", 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.holdSum), 1)
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('rejects')), 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.rejectedSum), 1)
                    ])
                  ]),
                  _hoisted_60,
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t('income')), 1),
                      _createElementVNode("div", null, _toDisplayString(props.row.revShareRevenueSum), 1)
                    ])
                  ])
                ])
              ]),
              key: "1"
            }
          : undefined
      ]), 1032, ["rows", "columns", "pagination", "loading", "onRequest", "rows-per-page-label"])
    ]),
    _: 1
  }))
}